import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Connect to Employment Hero", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " The first required step is to authenticate the system to access Employment Hero. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " To do so, please click the 'Authenticate' button below to connect to Employment Hero and generate an access code for the integration. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " A new window will open up and prompt you to authorise the application within Employment Hero. Please follow the prompts in that window, and do not close this tab. ", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, " Successfully received authentication from Employment Hero, please continue to the next stage. ", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (_ctx.authCode)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true),
    _createElementVNode("p", null, [
      (!_ctx.authCode)
        ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            type: "primary",
            onClick: _ctx.openAuthenticationWindow,
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Authenticate ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_van_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_button, {
                    icon: "tick",
                    type: "success",
                    disabled: true,
                    hairline: "",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" ✓ Authenticated ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_row, { justify: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_button, {
                            type: "primary",
                            onClick: _ctx.clickContinueButton,
                            loading: _ctx.nextButtonLoading,
                            disabled: _ctx.nextButtonDisabled
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Continue ")
                            ]),
                            _: 1
                          }, 8, ["onClick", "loading", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ])
  ]))
}